/*
 * Parcours d'achat pneus — ce qui manquait entre « Ajouter » et le paiement.
 *
 * Trois manques, constatés en parcourant le site comme un client qui ne le connaît pas :
 *
 *   1. La pastille du panier ne bougeait pas après un ajout fait en JavaScript (page résultats).
 *      Elle est rendue par Liquid au chargement : sans rafraîchissement elle annonce un panier
 *      plus vide qu'il ne l'est, ce qui est pire que pas de pastille du tout.
 *   2. Depuis le panier, aucun retour vers les résultats de la dimension cherchée. Le client
 *      devait refaire sa recherche depuis le début pour ajouter un deuxième train de pneus.
 *   3. Aucun repère de confiance sur la fiche ni au panier. Payer 200 € à un garage qu'on ne
 *      connaît pas demande de savoir qui encaisse, où l'on va, et qui appeler.
 *
 * Ce fichier ne touche jamais au panier de DEVIS (prestations), qui est un parcours distinct
 * porté par devis-widget.js : il ne lit et n'écrit que le panier Shopify et sa propre clé de
 * mémoire. Les deux ne doivent jamais se confondre, ni dans le code ni pour le client.
 */
(function () {
  'use strict';

  var cfg = window.MautoParcoursAchat || {};
  var CLE_DIMENSION = 'mautoDerniereDimensionPneu';

  function surPagePanier() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function surFichePneu() {
    return cfg.estFichePneu === true;
  }

  // ── Pastille du panier ──────────────────────────────────────────────────────────────────────
  // Même technique que le thème lui-même : l'API de rendu de section renvoie le HTML à jour de
  // la pastille, on remplace seulement son contenu. Aucune conséquence sur le panier réel si
  // l'appel échoue — le nombre sera juste au prochain chargement de page.
  function rafraichirPastille() {
    var pastille = document.getElementById('cart-icon-bubble');
    if (!pastille || !window.fetch) return Promise.resolve(false);
    return fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        if (!html) return false;
        var enveloppe = document.createElement('div');
        enveloppe.innerHTML = html;
        // sections/cart-icon-bubble.liquid rend le CONTENU du lien (icône + pastille), pas un
        // élément portant l'identifiant « cart-icon-bubble » — celui-ci est sur le <a> de
        // sections/header.liquid. Chercher cet identifiant dans la réponse ne trouve donc rien.
        // Shopify enveloppe la réponse dans #shopify-section-<nom> : on prend son contenu, et à
        // défaut la réponse telle quelle.
        var enveloppeSection = enveloppe.querySelector('#shopify-section-cart-icon-bubble');
        var contenu = enveloppeSection ? enveloppeSection.innerHTML : enveloppe.innerHTML;
        if (!contenu || !contenu.trim()) return false;
        pastille.innerHTML = contenu;
        return true;
      })
      .catch(function () { return false; });
  }

  // ── Mémoire de la dernière dimension cherchée ───────────────────────────────────────────────
  // Sert au lien « Continuer mes achats » du panier. On garde la requête telle quelle : c'est
  // elle qui reconstitue exactement la liste que le client regardait, filtres compris.
  function memoriserDimension(recherche) {
    if (!recherche) return;
    try { window.localStorage.setItem(CLE_DIMENSION, recherche); } catch (e) { /* navigation privée */ }
  }

  function lienRetourResultats() {
    var base = cfg.urlResultats || '/collections/pneus';
    var recherche = '';
    try { recherche = window.localStorage.getItem(CLE_DIMENSION) || ''; } catch (e) { recherche = ''; }
    return { url: base + recherche, precis: Boolean(recherche) };
  }

  function libelleDimension() {
    var recherche = '';
    try { recherche = window.localStorage.getItem(CLE_DIMENSION) || ''; } catch (e) { return ''; }
    if (!recherche) return '';
    var p = new URLSearchParams(recherche);
    var l = p.get('largeur'), h = p.get('hauteur'), d = p.get('diametre');
    return (l && h && d) ? (l + '/' + h + ' R' + d) : '';
  }

  // ── Réassurance ─────────────────────────────────────────────────────────────────────────────
  // Quatre repères, et pas un de plus : qui encaisse, où l'on va, ce qui est garanti, qui
  // appeler. Une liste plus longue se lit moins, donc rassure moins.
  function blocReassurance() {
    var bloc = document.createElement('div');
    bloc.className = 'mauto-reassurance';
    bloc.innerHTML =
      '<ul class="mauto-reassurance-liste">' +
        '<li><strong>Paiement sécurisé</strong><span>Carte bancaire, transaction chiffrée par Shopify Payments</span></li>' +
        '<li><strong>Retrait gratuit à l\'atelier</strong><span>12 rue de l\'Artisanat, Pont-Saint-Martin (44860) — aucun frais de port</span></li>' +
        '<li><strong>Garantie fabricant</strong><span>Pneus neufs, garantie du manufacturier contre les vices de fabrication</span></li>' +
        '<li><strong>Une question ?</strong><span>Appelez le garage au <a href="' + (cfg.telephoneLien || 'tel:+33240268661') + '">' + (cfg.telephone || '02 40 26 86 61') + '</a></span></li>' +
      '</ul>';
    return bloc;
  }

  function poserReassurance() {
    if (document.querySelector('.mauto-reassurance')) return;

    if (surFichePneu()) {
      // Sous les boutons de paiement : le client vient de voir le prix, c'est là que la question
      // « est-ce que je peux leur confier ma carte » se pose.
      var ancre = document.querySelector('.shopify-payment-button') || document.querySelector('product-form');
      if (ancre && ancre.parentNode) {
        ancre.parentNode.insertBefore(blocReassurance(), ancre.nextSibling);
      }
      return;
    }

    if (surPagePanier()) {
      // Au-dessus du bouton de commande, pour la même raison.
      var blocs = document.querySelector('.cart__ctas') || document.querySelector('[name="checkout"]');
      var hote = blocs && blocs.closest ? (blocs.closest('.cart__footer') || blocs.parentNode) : null;
      if (hote) hote.appendChild(blocReassurance());
    }
  }

  // ── « Continuer mes achats » au panier ──────────────────────────────────────────────────────
  function poserContinuerMesAchats() {
    if (!surPagePanier() || document.querySelector('.mauto-continuer')) return;
    var retour = lienRetourResultats();
    var dimension = libelleDimension();

    var lien = document.createElement('a');
    lien.className = 'mauto-continuer';
    lien.href = retour.url;
    lien.innerHTML = '&#8592; ' + (dimension
      ? 'Continuer mes achats en ' + dimension
      : 'Continuer mes achats — voir les pneus');

    // Au-dessus du récapitulatif, là où le regard remonte après avoir lu les lignes du panier.
    var items = document.querySelector('.cart__items') || document.querySelector('cart-items');
    if (items && items.parentNode) {
      items.parentNode.insertBefore(lien, items.nextSibling);
    } else {
      var principal = document.querySelector('.cart') || document.querySelector('main');
      if (principal) principal.appendChild(lien);
    }
  }

  // ── Confirmation d'ajout sur la fiche produit ───────────────────────────────────────────────
  // Le thème ouvre bien sa propre notification (« Article ajouté au panier »), mais il l'ancre
  // dans le flux du document, sous l'en-tête. Dès que le client a fait défiler jusqu'au bouton
  // d'achat — c'est-à-dire toujours — elle s'ouvre plusieurs centaines de pixels au-dessus de
  // l'écran et personne ne la voit. Mesuré : y = -276 px sur une fiche pneu.
  // On la laisse fonctionner (elle porte l'accessibilité et le focus) mais on la masque, et on
  // affiche à sa place le même message que sur la page résultats, ancré à l'écran.
  function afficherConfirmation(texte) {
    var existant = document.querySelector('.mauto-toast');
    if (existant) existant.remove();
    var toast = document.createElement('div');
    toast.className = 'mauto-toast';
    var libelle = document.createElement('span');
    libelle.textContent = texte;
    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.textContent = 'Voir mon panier';
    bouton.addEventListener('click', function () { window.location.href = cfg.urlPanier || '/cart'; });
    toast.appendChild(libelle);
    toast.appendChild(bouton);
    document.body.appendChild(toast);
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 8000);
  }

  function surveillerAjoutFicheProduit() {
    if (!surFichePneu() || typeof MutationObserver !== 'function') return;
    var notification = document.getElementById('cart-notification');
    if (!notification) return;
    notification.classList.add('mauto-notification-neutralisee');
    var observateur = new MutationObserver(function () {
      if (!notification.classList.contains('active')) return;
      // Le titre vient de la notification elle-même : c'est le libellé exact que le thème a
      // retenu pour la ligne ajoutée, variante comprise.
      var titre = notification.querySelector('.cart-notification-product__name');
      afficherConfirmation((titre ? titre.textContent.trim() : 'Article') + ' ajouté au panier');
      rafraichirPastille();
    });
    observateur.observe(notification, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    poserReassurance();
    poserContinuerMesAchats();
    surveillerAjoutFicheProduit();
  }

  window.MautoPanier = {
    rafraichirPastille: rafraichirPastille,
    memoriserDimension: memoriserDimension,
    lienRetourResultats: lienRetourResultats,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
